<script>
import ForgotPasswordForm from "../components/auth/forgot_password_form.vue";

export default {
  name: "ForgotPasswordView",
  components: {
    ForgotPasswordForm,
  },
};
</script>

<template>
  <eg-b-container>
    <eg-b-row>
      <eg-b-col>
        <forgot-password-form />
      </eg-b-col>
    </eg-b-row>
  </eg-b-container>
</template>
